export default __webpack_public_path__ + "static/media/LogoBig.48aa6165.png";